import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpContextConfig } from '../models/http-context-config';
import { CONFIG } from '../interceptors/loader.interceptor';

const calendarApi = `${environment.api}/calendar/`;
const config = new HttpContextConfig();
config.noSpinner = true;
const context = new HttpContext().set(CONFIG, config);

@Injectable({
  providedIn: 'root'
})
export class CalendarSmartService {
  constructor(private readonly http: HttpClient) {}

  /**
   * API che serve per modificare i giorni di smart ad uno o piu utenti
   * @param data {date: data del giorno, user_id: id degli utenti a cui vogliamo modificare lo smart, event_type_id: id dell'evento che vogliamo assegnare}
   */
  manageSmartForUsers(data: {
    date: string;
    user_ids: string[];
    event_type_id: number;
    is_request: boolean;
    is_global: boolean;
  }): Observable<any> {
    return this.http.post<any>(calendarApi + 'manageSmartForUsers', data, {
      context: context
    });
  }

  /**
   * API che serve per settare i posti
   * @param seats numero di posti da settare in un mese
   */
  seatSeatsForMonth(data: {
    start_day: string;
    end_day: string;
    seating: number;
  }): Observable<any> {
    return this.http.post<any>(calendarApi + 'setSeatingForMonth', data);
  }

  setDayEvent(event_type_id: number, limit: number, date: string) {
    const data = {
      date: date,
      event_type_id: event_type_id,
      seating: limit
    };
    return this.http.post<any>(calendarApi + 'setDayEvent', data, {
      context: context
    });
  }

  generateMonth(dateOfMonth: string, copyLast: boolean) {
    const obj = {
      date: dateOfMonth,
      copyLast: copyLast
    };
    return this.http.post<any>(calendarApi + 'generateDaysOfMonth', obj);
  }

  storeMaxSmartDaysForUser(user_id: string, maxSmartDays: number) {
    const data = {
      user_id: user_id,
      days: maxSmartDays
    };
    return this.http.post<any>(calendarApi + 'storeMaxSmartDaysForUser', data);
  }

  storeDesiredSmartDaysForUser(desiredSmart: number) {
    return this.http.post<any>(calendarApi + 'storeDesiredSmartDaysForUser', {
      days: desiredSmart
    });
  }
}
